import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { Flame, LogOut, BookOpen, Sparkles, Droplet, Home } from "lucide-react";
import { LightToggle } from "./LightToggle";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [waiting, setWaiting] = useState(null);

  useEffect(() => {
    api.get("/well/status").then(({ data }) => setWaiting(data.waiting)).catch(() => {});
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-40 w-full backdrop-blur-xl border-b"
      style={{
        backgroundColor: "var(--sanctuary-veil)",
        borderColor: "rgba(232,228,217,0.6)",
      }}
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
        <Link
          to="/"
          data-testid="nav-home-icon"
          aria-label="Home"
          title="Home"
          className="inline-flex items-center justify-center w-9 h-9 rounded-full cursor-pointer transition hover-paper"
          style={{ color: "var(--sanctuary-gold)" }}
        >
          <Home className="w-5 h-5" strokeWidth={1.25} />
        </Link>
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 group cursor-pointer">
          <span
            className="w-8 h-8 rounded-full flex items-center justify-center"
            style={{ background: "linear-gradient(135deg, var(--sanctuary-accent), var(--sanctuary-gold))" }}
          >
            <Flame className="w-4 h-4 text-white" strokeWidth={1.5} />
          </span>
          <span className="font-serif-display text-xl tracking-tight" style={{ color: "var(--sanctuary-ink)" }}>
            Inlight
          </span>
        </Link>
        </div>

        <nav className="flex items-center gap-2 md:gap-4">
          <LightToggle />
          <Link
            to="/well"
            data-testid="nav-well-link"
            className="inline-flex items-center gap-1.5 text-sm px-3 py-2 rounded-full transition hover-paper"
            style={{ color: "var(--sanctuary-gold)" }}
          >
            <Droplet className="w-4 h-4" strokeWidth={1.5} />
            <span className="hidden sm:inline">The Well</span>
            {waiting != null && waiting > 0 && (
              <span
                data-testid="nav-well-counter"
                className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[11px]"
                style={{ backgroundColor: "var(--sanctuary-gold)", color: "white" }}
              >
                {waiting}
              </span>
            )}
          </Link>
          {user && user !== false ? (
            <>
              <Link
                to="/builder"
                data-testid="nav-create-link"
                className="hidden sm:inline-flex items-center gap-1.5 text-sm px-3 py-2 rounded-full transition hover-paper"
                style={{ color: "var(--sanctuary-ink-soft)" }}
              >
                <Sparkles className="w-4 h-4" strokeWidth={1.5} />
                New prayer
              </Link>
              <Link
                to="/library"
                data-testid="nav-library-link"
                className="inline-flex items-center gap-1.5 text-sm px-3 py-2 rounded-full transition hover-paper"
                style={{ color: "var(--sanctuary-ink-soft)" }}
              >
                <BookOpen className="w-4 h-4" strokeWidth={1.5} />
                Library
              </Link>
              {user.email === "admin@inlight.app" && (
                <Link
                  to="/admin"
                  data-testid="nav-admin-link"
                  className="hidden md:inline-flex items-center gap-1.5 text-sm px-3 py-2 rounded-full transition hover-paper"
                  style={{ color: "var(--sanctuary-gold)" }}
                >
                  Keeper
                </Link>
              )}
              <button
                onClick={handleLogout}
                data-testid="logout-button"
                className="inline-flex items-center gap-1.5 text-sm px-3 py-2 rounded-full transition hover-paper"
                style={{ color: "var(--sanctuary-ink-soft)" }}
              >
                <LogOut className="w-4 h-4" strokeWidth={1.5} />
                <span className="hidden sm:inline">Sign out</span>
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                data-testid="nav-login-link"
                className="text-sm px-4 py-2 rounded-full transition hover-paper"
                style={{ color: "var(--sanctuary-ink-soft)" }}
              >
                Sign in
              </Link>
              <Link
                to="/builder"
                data-testid="nav-register-link"
                className="text-sm px-5 py-2.5 rounded-full btn-primary"
              >
                Begin
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
